import {Component, ChangeDetectionStrategy} from "@angular/core";

import {AppService} from "app/app.service";
import {environment} from "environments/environment";
import {CacheService} from "framework/services/cache.service";
import moment from "framework/utils/moment";

@Component({
               selector  : "o3-root",
               template  : "<router-outlet></router-outlet>",
               changeDetection: ChangeDetectionStrategy.Eager,
               standalone: false
           })
export class RootComponent
{
    constructor(private appService: AppService,
                private cacheService: CacheService)
    {
        // Fetch the version from the page.
        appService.environment.version = environment.version;

        // Change your page title here
        appService.setState("topnavTitle", "Loading");

        // start a new cache session
        this.cacheService.init();

        // update moment date formats
        moment.updateLocale("en", {
            longDateFormat: {
                LT  : "h:mm A",
                LTS : "h:mm:ss A",
                L   : "MM/DD/YYYY",
                l   : "M/D/YY",
                LL  : "MM/DD/YYYY h:mm A",
                ll  : "M/DD/YY h:mm A",
                LLL : "MM/DD/YYYY h:mm A",
                lll : "M/DD/YY h:mm A",
                LLLL: "MM/DD/YYYY h:mm A",
                llll: "M/DD/YY h:mm A"
            }
        });

    }
}
